"use client";

import { useId } from "react";

export default function HeroMesh() {
  const blurId = `${useId().replace(/:/g, "")}-mesh-blur`;

  return (
    <div className="hero-mesh pointer-events-none absolute inset-0" aria-hidden>
      <svg
        className="hero-mesh-svg"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <filter
            id={blurId}
            x="-25%"
            y="-25%"
            width="150%"
            height="150%"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur stdDeviation="72" />
          </filter>
        </defs>
        <g filter={`url(#${blurId})`} className="hero-mesh-blobs">
          <ellipse
            className="hero-mesh-blob"
            cx="240"
            cy="160"
            rx="420"
            ry="320"
            fill="#008cff"
            opacity="0.48"
          />
          <ellipse
            className="hero-mesh-blob"
            cx="1220"
            cy="120"
            rx="380"
            ry="300"
            fill="#7c6cf0"
            opacity="0.36"
          />
          <ellipse
            className="hero-mesh-blob"
            cx="1080"
            cy="760"
            rx="460"
            ry="340"
            fill="#3ec8ff"
            opacity="0.38"
          />
          <ellipse
            className="hero-mesh-blob"
            cx="220"
            cy="780"
            rx="340"
            ry="280"
            fill="#a78bfa"
            opacity="0.26"
          />
          <ellipse
            className="hero-mesh-blob"
            cx="740"
            cy="200"
            rx="300"
            ry="220"
            fill="#7dd3fc"
            opacity="0.32"
          />
          <ellipse
            className="hero-mesh-blob"
            cx="720"
            cy="430"
            rx="360"
            ry="260"
            fill="#ffffff"
            opacity="0.62"
          />
        </g>
      </svg>
      <div className="hero-mesh-veil" />
    </div>
  );
}
